"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import type { ComponentProps } from "react"

import { contextualContactHref } from "@/lib/contact-routing"

export function ContactLink({
  href,
  ...props
}: Omit<ComponentProps<typeof Link>, "href"> & { href: string }) {
  const pathname = usePathname()
  return <Link {...props} href={contextualContactHref(href, pathname)} />
}
